module.exports = __webpack_public_path__ + "img/downward01.af22851e.png";